import React, { useState, useEffect } from 'react'

import Grid from '@mui/material/Grid';

import BusinessprocessFilterCriteria from './BusinessprocessFilterCriteria'
import BusinessprocessList from './BusinessprocessList'
import MyPageContainer from '../../core/template/MyPageContainer';
import {getListAPI} from './BusinessprocessAPI';
import {transformToCardFormat} from '../../core/js/FormUtils'
import {getPathVariable} from '../../core/js/UrlUtils';

import { useSearchParams } from "react-router-dom";
import { useSelector, useDispatch } from 'react-redux';
import {setBusinessprocessDashboardBusinessprocessList } from '../../store/slice/ManufSlice';

export default function BusinessprocessListView({setShowEdit,setBusinessprocessId}){
    const {filterCriteria} = useSelector((state)=>state.manufslice.businessprocessDashboard);   

    const [filteredBusinessprocessList, setFilteredBusinessprocessList] = React.useState([]);
    const [cardList, setCardList] = useState([]);
    const [searchParams, setSearchParams] = useSearchParams();
    const { showfilter } = useSelector((state) => state.confslice);
    const { businessprocessDashboard } = useSelector((state) => state.manufslice);
    
    function dataFetchCallBack(){
    }

    useEffect(()=>{
      if (businessprocessDashboard.businessprocessList.length>-1){
        setFilteredBusinessprocessList(businessprocessDashboard.businessprocessList);
        transformToCardFormat(businessprocessDashboard.businessprocessList, setCardList);
      }
    },[businessprocessDashboard.businessprocessList])

    useEffect(()=>{
          transformToCardFormat(filteredBusinessprocessList, setCardList);
      },[filteredBusinessprocessList])

    useEffect(()=>{
        if (filterCriteria.title==='' ){
            setFilteredBusinessprocessList(businessprocessDashboard.businessprocessList);
            transformToCardFormat(businessprocessDashboard.businessprocessList, setCardList);

        } else {
            setFilteredBusinessprocessList(
                businessprocessDashboard.businessprocessList
                    .filter(businessprocess=> businessprocess.title.toString().toUpperCase().includes(filterCriteria.title.toString().toUpperCase()))

                
            )
            

            //transformToCardFormat(businessprocessDashboard.filteredBusinessprocessList, setCardList);
        }
      },[filterCriteria])
  
     return(
        <Grid container direction="column" >
            <Grid item lg={12}>
                <BusinessprocessList
                    setShowEdit={setShowEdit}
                    setBusinessprocessId = {setBusinessprocessId}
                    tableList={filteredBusinessprocessList}
                    cardList={cardList}
                    />
          </Grid>
      </Grid>
    )
}